export enum RegistrationStatus {
  Decommissioned = 0,
  Planned = 1,
  Operational = 2,
  Unknown = 99
}
